import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大内容板块，覆盖你喜欢的每一种娱乐类型
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleClick(cat.slug)}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">{cat.count} 部</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}